import { render } from 'preact';
import { App } from './App';
// C1 — the design language's tokens are the vocabulary, and they load FIRST:
// styles/tokens.css is now a compatibility bridge that redefines this app's
// legacy variable names on top of these, so this order is load-bearing rather
// than cosmetic (see that file's header for what the bridge is, and when it
// is meant to die).
import '@vowric/ui/src/styles/tokens.css';
import './styles/global.css';
// S1 — atlas-cockpit's own token set, deliberately outside the semantic
// layer above (see the file's own header for why).
import './styles/cockpit-tokens.css';
import { applyTheme } from './lib/theme';
import { answerWorkerRouteQueries } from './lib/swMessages';

// Before the first render, so nothing paints in the wrong theme for a frame.
// EVERY route gets this, portals included — a theme is not a skin (ce1c3046
// governs the chassis and its materials, not light vs dark).
applyTheme();

const root = document.getElementById('app');
if (root) {
  render(<App />, root);
}

// Register the app-shell service worker in production builds only — dev
// mode's own HMR/module graph makes an installed SW actively counterproductive
// (stale-cached modules), and the worker's job (offline app shell, never
// caching /api/) only matters once the app is actually deployed.
// C6a: registered as a MODULE worker so sw.js can import its fetch decision
// from sw-policy.js — the same pure module the unit suite asserts the
// never-hold-auth-state invariant against (see both files' headers).
// CV6b: the app answers the worker's ONE question — "which route are you
// showing?" — from MODULE SCOPE. `WindowClient.url` does not track a hash
// change (measured; see lib/swMessages' answerWorkerRouteQueries) and this
// app is a hash router, so without this reply the worker cannot tell that
// the thread a push belongs to is the one already on screen: it would buzz
// the phone while the human is reading the message, and never refresh the
// thread. Outside any component, because the question can arrive mid-render.
answerWorkerRouteQueries();

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { type: 'module' }).catch(() => {});
  });
}
